module.exports = __webpack_public_path__ + "images/application/promo/retention-add-on-23fe1801.gif";